export type Severity = 'error' | 'success' | 'warning' | 'info';
type Callback = (message: string,severity: Severity, subMessgae?: string) => void;

class EventEmitter {
    private events: { [key: string]: Callback[] } = {};

    on(event: string, callback: Callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    emit(event: string, message: string,severity:Severity = 'error', subMessgae?: string) {
        if (this.events[event]) {
            this.events[event].forEach(callback => callback(message,severity, subMessgae));
        }
    }
}

const eventEmitter = new EventEmitter();
export default eventEmitter;
